import { TextField, Autocomplete, styled } from "@material-ui/core";
import { FieldConfig, useField } from "formik";

interface Props extends FieldConfig {
  label?: any;
  data: any[];
  size?: "small" | "medium";
  dataTextField: string;
  dataValueField: string;
  onChange?: (value: any) => void;
  onClick?: (event: React.MouseEvent) => void;
  disable?: boolean;
  disableClearable?: boolean;
  groupBy?: any;
};

const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: theme.palette.primary.main,
  opacity: 1,
  transparency: 0,
  fontWeight: 'bold',
  backgroundColor: theme.palette.background.default
}));

const GroupItems = styled('ul')({
  padding: 0,
});

const SelectField = ({
  label,
  data,
  dataTextField,
  dataValueField,
  onChange,
  onClick,
  size,
  disable = false,
  disableClearable = false,
  groupBy,
  ...props
}: Props) => {
  const [field, meta, form] = useField(props);
  const { value: selectedValue } = field;

  return (
    <Autocomplete
      noOptionsText="No Data Available"
      value={data.find((x) => x[dataValueField] === selectedValue) || null}
      onChange={(event: any, newValue) => {
        if (onChange) {
          onChange(newValue);
        } else if (newValue !== null) {
          form.setValue(newValue[dataValueField]);
        } else {
          form.setValue(null);
        }
        event.stopPropagation();
      }}
      options={data}
      disabled={disable}
      size={size}
      getOptionLabel={(option) => option[dataTextField]?.toString() || ""}
      getOptionSelected={(option, value) =>
        option[dataValueField] === value[dataValueField]
      }
      groupBy={groupBy}
      renderGroup={(params) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
      disableClearable={disableClearable}
      renderInput={(params) => (
        <TextField
          {...params}
          disabled={disable}
          label={label}
          onBlur={field.onBlur}
          onClick={onClick}
          {...props}
          helperText={meta.touched && meta.error}
          error={Boolean(meta.touched && meta.error)}
          inputProps={{
            ...params.inputProps,
            form: {
              autocomplete: "off",
            },
          }}
        />
      )}
    />
  );
};

export default SelectField;
